import { t } from "i18next";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

function DeleteAssistantModal({ show, handleClose, onClickDeletehandler, loading }) {

  return (
    <Modal
      show={show}
      centered
      onHide={handleClose}
      size="sm"
      className="delete-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="ionbx">
            <img src="/images/bin.svg" alt="dustbin" />
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-0 ">
        <div className="modal-headerd">{t("deleteAssistantModalHeader")}</div>
        <div className="deltemsg">{t("deleteAssistantModalMsg")}</div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center flex-nowrap border-0 pt-3">
        <button className="cancelbtn" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="deletebtn"
          disabled={loading}
          onClick={() => {
            onClickDeletehandler();
          }}
        >
          {loading ? (
            <Spinner
              animation="border"
              style={{ width: "16px", height: "16px" }}
            />
          ) : (
            t("removebtn")
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteAssistantModal;
